import { render, staticRenderFns } from "./globalLoading.vue?vue&type=template&id=104a8304&scoped=true&"
import script from "./globalLoading.vue?vue&type=script&lang=js&"
export * from "./globalLoading.vue?vue&type=script&lang=js&"
import style0 from "./globalLoading.vue?vue&type=style&index=0&id=104a8304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104a8304",
  null
  
)

component.options.__file = "globalLoading.vue"
export default component.exports